// src/context/AuthContext.js
import React, { createContext, useState, useEffect } from 'react';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [userRole, setUserRole] = useState(() => localStorage.getItem('userRole') || '');
  const [userName, setUserName] = useState(() => localStorage.getItem('userName') || '');
  const [isAuthenticated, setIsAuthenticated] = useState(!!localStorage.getItem('accessToken'));
  const [loading, setLoading] = useState(true);
  const [isInitialLoad, setIsInitialLoad] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('accessToken');
    const roleFromStorage = localStorage.getItem('userRole');
    const nameFromStorage = localStorage.getItem('userName');

    if (token) {
      setIsAuthenticated(true);
      setUserRole(roleFromStorage || '');
      setUserName(nameFromStorage || '');
    } else {
      setIsAuthenticated(false);
      setUserRole('');
      setUserName('');
    }

    setLoading(false);
    setIsInitialLoad(false);
  }, []);

  const logout = () => {
    setIsAuthenticated(false);
    setUserRole('');
    setUserName('');
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('userRole');
    localStorage.removeItem('userName');
    setLoading(false);
  };

  return (
    <AuthContext.Provider
      value={{
        userRole,
        userName,
        isAuthenticated,
        setIsAuthenticated,
        setUserRole,
        setUserName,
        logout,
        loading,
        isInitialLoad,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
